import React, { useState } from "react";
import { ImSearch } from "react-icons/im";
import "../Styles/NavBarStyle.css";
import "animate.css";
import { Routes, Route } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Movies from "./Movies";
import TvShows from "./TvShows";
import Pricing from "./Pricing";
import Trends from "./Trends";
import { createContext } from "react";

export const container = createContext();

const Navbar = () => {
  const [toggle, setToggle] = useState(true);
  const [inputValue, setInputValue] = useState("");

  return (
    <container.Provider value={{ toggle, inputValue }}>
      <>
        <nav className="wrap">
          <div className="nav-options">
            <h1 id={toggle ? "" : "heading"}>MOVIESFLIX</h1>
            <NavLink className="text-link" to="/">
              <span className="span" id={toggle ? "" : "movieslight"}>
                Movies
              </span>
            </NavLink>
            <NavLink className="text-link" to="/TvShows">
              <span className="span" id={toggle ? "" : "movieslight"}>
                TV Shows
              </span>
            </NavLink>
            <NavLink className="text-link" to="/Trending">
              <span className="span" id={toggle ? "" : "movieslight"}>
                Trending
              </span>
            </NavLink>
            <NavLink className="text-link" to="/Pricing">
              <span className="span" id={toggle ? "" : "movieslight"}>
                Pricing
              </span>
            </NavLink>

            <input
              type="text"
              className="search animate__animated animate__pulse"
              placeholder="Search Anything"
              onChange={(e) => setInputValue(e.target.value)}
            />
            <ImSearch className="icon " />
            <div className="nav-togle">
              <div id="color-switch" onClick={() => setToggle(!toggle)}>
                <div
                  id={toggle ? "color-switcher-mover" : "Color-switcher-moved"}
                ></div>
              </div>
            </div>
          </div>
        </nav>
        <Routes>
          <Route path="/" element={<Movies />} />
          <Route path="TvShows" element={<TvShows />} />
          <Route path="Trending" element={<Trends />} />
          <Route path="Pricing" element={<Pricing />} />
        </Routes>
      </>
    </container.Provider>
  );
};

export default Navbar;
